let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jKf17")).then(() => parcelRequire('N1TKZ'));